import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchProductById } from '../api/products';
import { API_BASE_URL } from '../utils/constants';
import { useCart } from '../context/CartContext';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState(null);
  const [thumbStart, setThumbStart] = useState(0);
  const visibleThumbs = 3;
  const { addToCart } = useCart();
  useEffect(() => {
    const loadProduct = async () => {
      try {
        const data = await fetchProductById(id);
        setProduct(data);
        if (data.images?.length > 0) {
          const url = `${API_BASE_URL}/uploads/${data.images[0].filename}`;
          setMainImage(url);
        } else if(data.image_url) {
          setMainImage(data.image_url);
        }
      } catch (err) {
        console.error('Error loading product:', err);
      } finally {
        setLoading(false);
      }
    };
    loadProduct();
  }, [id]);

  if (loading) return <p className="text-center mt-10">Loading...</p>;
  if (!product) return <p className="text-center mt-10">Product not found.</p>;

  const thumbnails = product.images || [];

  const handleThumbNav = (direction) => {
    const newStart = thumbStart + direction;
    if (newStart >= 0 && newStart + visibleThumbs <= thumbnails.length) {
      setThumbStart(newStart);
    }
  };
  
  return (
    <div className="p-20 max-w-4xl mx-auto grid md:grid-cols-2 gap-6">
      <div>
        {mainImage ? (
          <img
            src={mainImage}
            alt="Main"
            className="w-full h-auto object-cover border rounded mb-4"
          />
        ) : (
          <div className="w-full h-auto flex items-center justify-center bg-gray-100 text-sm text-gray-500 mb-4 productDetail-no-image">
          No Image
        </div>
        )}

        {thumbnails.length > 1 && (
          <div className="flex items-center gap-2">
            {thumbStart > 0 && (
              <button
                onClick={() => handleThumbNav(-1)}
                className="px-2 py-1 border rounded"
              >←</button>
            )}

            <div className="flex gap-2 overflow-x-auto">
              {thumbnails.slice(thumbStart, thumbStart + visibleThumbs).map((img, index) => (
                <img
                  key={index}
                  src={`${API_BASE_URL}/uploads/${img.filename}`}
                  alt={`Thumb ${index}`}
                  onClick={() => setMainImage(`${API_BASE_URL}/uploads/${img.filename}`)}
                  className={`w-20 h-20 object-cover border rounded cursor-pointer ${mainImage?.filename === img.filename ? 'ring-2 ring-black' : ''}`}
                />
              ))}
            </div>

            {thumbStart + visibleThumbs < thumbnails.length && (
              <button
                onClick={() => handleThumbNav(1)}
                className="px-2 py-1 border rounded"
              >→</button>
            )}
          </div>
        )}
      </div>

      <div>
        <h1 className="text-2xl font-bold">{product.subname ? product.subname : product.product_name}</h1>
        <p className="text-gray-600 italic text-xs mb-2">{product.product_group_name}</p>
        <p className="text-gray-600 mb-2">{product.description}</p>
        <p className="text-lg font-semibold mb-4">
          {parseFloat(product.price).toFixed(2)} rsd
        </p>

        {/* Quantity Selector */}
        <div className="mb-4 flex items-center gap-2">
          <button
            onClick={() => setQuantity(q => Math.max(1, q - 1))}
            className="px-3 py-1 border rounded"
          >−</button>
          <span>{quantity}</span>
          <button
            onClick={() => setQuantity(q => q + 1)}
            className="px-3 py-1 border rounded"
          >+</button>
        </div>

        <button
          className="bg-black text-white px-4 py-2 rounded"
          onClick={() => addToCart(product, quantity)}
        >
          Dodaj u korpu
        </button>
      </div>
    </div>
  );
};

export default ProductDetail;
